/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceRecommendationResponse {
    getFixupPrototypeFunction() { return ResourceRecommendationResponse.fixupPrototype; }

    static newInstance(model: Partial<ResourceRecommendationResponse>): ResourceRecommendationResponse {
        let obj = Object.assign(new ResourceRecommendationResponse(), model);
        ResourceRecommendationResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceRecommendationResponse>): ResourceRecommendationResponse {
        if (!model) return null;
        return ResourceRecommendationResponse.newInstance(<ResourceRecommendationResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceRecommendationResponse) {
        if (!obj) return;

        models.ResourceRecommendationResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceRecommendationResponse): boolean {
        Object.setPrototypeOf(obj, ResourceRecommendationResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.ResourceRecommendationsBatchResponse.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.ResourceRecommendationsBatchResponse; };

}
